export const API = {
  URL: "https://api.weatherapi.com/v1",
  FORECAST: "/forecast.json",
};

export const WEATHER_DATA = {};
